module.exports = __webpack_public_path__ + "img/img_beneficio2.d076d0bc.png";